import React, { useEffect } from "react";
import Header from "../Component/Header";
import { Link } from "react-router-dom";
const CareerCornerMissionMole = () => {
  useEffect(() => {
    document.title =
      "Career Corner : Mission N-MOLE -  The Air Force School Subroto Park";
  }, []);
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
          </li>
          <li>Career Corner : Mission N-MOLE</li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1> Career Corner : Mission N-MOLE </h1>
            </div>
          </div>
          <div className="row">
            {/* <div class="col-lg-6">
              <div class="linktab">
                <a
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Mission N-mole.pdf"
                  target="_blank"
                >
                  {" "}
                  Mission N-mole Circular Regarding Career{" "}
                </a>
              </div>
            </div> */}
            <div class="col-lg-6">
              <div class="linktab">
                <a
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/AcademicCourses.pdf"
                  target="_blank"
                >
                  {" "}
                  Compendium Of Academic Courses After +2{" "}
                </a>
              </div>
            </div>

            <div class="col-lg-4">
              <div class="linktab">
                <a
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/CareerGuidance.pdf"
                  target="_blank"
                >
                  {" "}
                  Cbse’s Career Guidance{" "}
                </a>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="linktab">
                <a
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/CareerOptions.pdf"
                  target="_blank"
                >
                  {" "}
                  Career Options{" "}
                </a>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="linktab">
                <a
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/JeeMainsNotification.pdf"
                  target="_blank"
                >
                  {" "}
                  Jee Mains Notification{" "}
                </a>
              </div>
            </div>
            <div class="col-lg-12">
              <div class="linktab">
                <a
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/EntranceExams2025.pdf"
                  target="_blank"
                >
                  {" "}
                  CBSE - Resource Material: Parents’ Handbook on Careers after
                  School in India, Entrance Exams 2025 Guide and 21 Higher
                  Education Vertical Books{" "}
                </a>
              </div>
              <p>
                <b> NEET 2025</b>
              </p>
              <ul className="list mainlist">
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/NEET-2025-mocktestpaper1.pdf"
                    target="_blank"
                  >
                    {" "}
                    MOCK TEST PAPER - 1{" "}
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/NEET-2025-mocktestpaper2.pdf"
                    target="_blank"
                  >
                    {" "}
                    MOCK TEST PAPER - 2{" "}
                  </Link>{" "}
                </li>
              </ul>
            </div>

            <h6>Achievements </h6>
            <p>
              <b>2026-2027</b>
            </p>
            <div className="col-lg-6">
 <img
  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/Priyam_Dhar.jpeg"
  className="mx-auto d-block img-fluid"
/></div>
<br/>

             <p>05 students have cleared the written exam of NDA I 2026 </p>
 <div className="col-lg-6">
              <img
                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/NDA-I-2026.jpg"
                className="img-fluid"
              />
            </div>


            <p>
              <b>2025-2026</b>
            </p>

           

            <p>14 students have cleared the written exam of NDA II 2025 </p>
            <div className="col-lg-6">
              <img
                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/NEET-Ach.jpg"
                className="img-fluid"
              />
            </div>

            <p>
              <Link
                to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/NDA-I-2025-1.pdf"
                target="_blank"
              >
                06 students have cleared the written exam of NDA I 2025 - Click
                Here
              </Link>
            </p>
            <p>
              <b>2024-2025</b>
            </p>
            <p>
              <Link
                to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/NDA-II-2024.pdf"
                target="_blank"
              >
                04 students have cleared the written exam of NDA II 2024 - Click
                Here
              </Link>
            </p>

            <p>JEE ADVANCE 2024-25</p>
            <div className="jeemains">
              <div className="jeemainsbox">
                <div className="jeemainsboximg">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/JEEMAINS2024-25-1.jpg"
                    className="img-fluid"
                  />
                </div>
                <div className="jeemainsboxdesc">
                  <p>
                    Name :- Saksham Srijan
                    <br />
                    Class :- XII-D <br />
                    CRL Rank :- 1347
                    <br /> IIT BHU CSc
                  </p>
                </div>
              </div>
              <div className="jeemainsbox">
                <div className="jeemainsboximg">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/JEEMAINS2024-25-2.jpg"
                    className="img-fluid"
                  />
                </div>
                <div className="jeemainsboxdesc">
                  <p>
                    Name :- Aarush Jha <br />
                    Class :- XII-E <br />
                    CRL Rank :- 7343
                  </p>
                </div>
              </div>
              <div className="jeemainsbox">
                <div className="jeemainsboximg">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/JEEMAINS2024-25-3.jpg"
                    className="img-fluid"
                  />
                </div>
                <div className="jeemainsboxdesc">
                  <p>
                    {" "}
                    Name :- Ridhim Mittal <br />
                    Class :- XII-E <br />
                    CRL Rank :- 7525{" "}
                  </p>
                </div>
              </div>
              <div className="jeemainsbox">
                <div className="jeemainsboximg">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/JEEMAINS2024-25-4.jpg"
                    className="img-fluid"
                  />
                </div>
                <div className="jeemainsboxdesc">
                  <p>
                    Name :- Ajitesh Sharma
                    <br />
                    Class :- XII-E
                    <br />
                    CRL Rank :- 16882
                  </p>
                </div>
              </div>
              <div className="jeemainsbox">
                <div className="jeemainsboximg">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/JEEMAINS2024-25-5.jpg"
                    className="img-fluid"
                  />
                </div>
                <div className="jeemainsboxdesc">
                  <p>
                    Name :- Anush Sharma <br />
                    Class :- XII-B <br />
                    CRL Rank :- 31000
                  </p>
                </div>
              </div>
              <div className="jeemainsbox">
                <div className="jeemainsboximg">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/JEEMAINS2024-25-0.jpg"
                    className="img-fluid"
                  />
                </div>
                <div className="jeemainsboxdesc">
                  <p>
                    Name :- Padm Neelabh
                    <br />
                    Class :- XII-B <br />
                    IAT Rank :- AIR 375
                    <br /> IISER Pune
                  </p>
                </div>
              </div>
              <div className="jeemainsbox">
                <div className="jeemainsboximg">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/JEEMAINS2024-25-6.jpg"
                    className="img-fluid"
                  />
                </div>
                <div className="jeemainsboxdesc">
                  <p>
                    Name :- Aaditya Mishra
                    <br />
                    Class :- XII-B (2023-24) <br />
                    Rank :- AIR 2427
                    <br /> RML
                  </p>
                </div>
              </div>
            </div>
            <p>
              <b>2023-2024</b>
            </p>
            <p>JEE MAINS 2024</p>
            <div className="jeemains">
              <div className="jeemainsbox">
                <div className="jeemainsboximg">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/JEEMAINS2024-1.png"
                    className="img-fluid"
                  />
                </div>
                <div className="jeemainsboxdesc">
                  <p>
                    Name :- Garv Jain <br />
                    Class :- XII-D <br />
                    Percentile :- 99.92{" "}
                  </p>
                </div>
              </div>
              <div className="jeemainsbox">
                <div className="jeemainsboximg">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/JEEMAINS2024-2.jpg"
                    className="img-fluid"
                  />
                </div>
                <div className="jeemainsboxdesc">
                  <p>
                    Name :- Incia Bajwa <br />
                    Class :- XII-E <br />
                    Percentile :- 98.94
                  </p>
                </div>
              </div>
              <div className="jeemainsbox">
                <div className="jeemainsboximg">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/JEEMAINS2024-3.jpg"
                    className="img-fluid"
                  />
                </div>
                <div className="jeemainsboxdesc">
                  <p>
                    {" "}
                    Name :- Anagh Sriram <br />
                    Class :- XII-D <br />
                    Percentile :- 98.8{" "}
                  </p>
                </div>
              </div>
              <div className="jeemainsbox">
                <div className="jeemainsboximg">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/JEEMAINS2024-4.jpg"
                    className="img-fluid"
                  />
                </div>
                <div className="jeemainsboxdesc">
                  <p>
                    Name :- Pranav Shukla
                    <br />
                    Class :- XII-D
                    <br />
                    Percentile :- 98.77
                  </p>
                </div>
              </div>
              <div className="jeemainsbox">
                <div className="jeemainsboximg">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/JEEMAINS2024-5.jpg"
                    className="img-fluid"
                  />
                </div>
                <div className="jeemainsboxdesc">
                  <p>
                    Name :- Aditya Kushwaha <br />
                    Class :- XII-D <br />
                    Percentile :- 98.6
                  </p>
                </div>
              </div>
              <div className="jeemainsbox">
                <div className="jeemainsboximg">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/JEEMAINS2024-6.jpg"
                    className="img-fluid"
                  />
                </div>
                <div className="jeemainsboxdesc">
                  <p>
                    Name: Vaishnavi <br />
                    Veerangana Avanti Bai Lodhi Autonomous State Medical
                    College, Etah, UP <br />
                    2023-24 Batch{" "}
                  </p>
                </div>
              </div>
              <div className="jeemainsbox">
                <div className="jeemainsboximg">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/JEEMAINS2024-7.jpg"
                    className="img-fluid"
                  />
                </div>
                <div className="jeemainsboxdesc">
                  <p>
                    Name: Kashish <br />
                    Maulana Azad Medical College <br />
                    2022-23 Batch{" "}
                  </p>
                </div>
              </div>
              <div className="jeemainsbox">
                <div className="jeemainsboximg">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/JEEMAINS2024-8.jpg"
                    className="img-fluid"
                  />
                </div>
                <div className="jeemainsboxdesc">
                  <p>
                    Name: Tejas Goyal <br />
                    University College of Medical Sciences, Delhi <br />
                    2022-23 Batch
                  </p>
                </div>
              </div>
              <div className="jeemainsbox">
                <div className="jeemainsboximg">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/JEEMAINS2024-9.jpg"
                    className="img-fluid"
                  />
                </div>
                <div className="jeemainsboxdesc">
                  <p>
                    Name: Sneha <br />
                    Vardhman Mahavir Medical College Safdarjung Hospital, New
                    Delhi <br />
                    2023-24 Batch{" "}
                  </p>
                </div>
              </div>
            </div>
            <p>
              <Link
                to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/NDA-II-2023.pdf"
                target="_blank"
              >
                13 students have cleared the written exam of NDA II 2023 - Click
                Here
              </Link>
            </p>
            <div className="col-lg-6">
              <img
                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/dakshdutta.jpg"
                className="img-fluid"
              />
            </div>
            <div className="col-lg-6">
              <img
                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/gurtejsing.jpg"
                className="img-fluid"
              />
            </div>
            <p>
              <b>2022-2023</b>
            </p>
            <div className="jeemains">
              <div className="jeemainsbox">
                <div className="jeemainsboximg">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/JEEMAINS2023-1.jpg"
                    className="img-fluid"
                  />
                </div>
                <div className="jeemainsboxdesc">
                  <p>
                    Name :- Parth Arya Bhat <br />
                    Class :- XII-D <br />
                    Percentile :- 99.30 <br />
                    Joined IIT Kanpur
                  </p>
                </div>
              </div>
              <div className="jeemainsbox">
                <div className="jeemainsboximg">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/JEEMAINS2023-2.jpg"
                    className="img-fluid"
                  />
                </div>
                <div className="jeemainsboxdesc">
                  <p>
                    Name: Keshav Sethi <br />
                    Class: XII-D <br />
                    Percentile: 99.46 <br />
                    Joined NSUT
                  </p>
                </div>
              </div>
              <div className="jeemainsbox">
                <div className="jeemainsboximg">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/JEEMAINS2023-3.jpg"
                    className="img-fluid"
                  />
                </div>
                <div className="jeemainsboxdesc">
                  <p>
                    {" "}
                    Name- Nishit Singhal <br />
                    Class- XII-D <br />
                    Percentile- 99.29 <br />
                    Joined DTU
                  </p>
                </div>
              </div>
              <div className="jeemainsbox">
                <div className="jeemainsboximg">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/JEEMAINS2023-4.jpg"
                    className="img-fluid"
                  />
                </div>
                <div className="jeemainsboxdesc">
                  <p>
                    Name: Sashreek <br />
                    Joined IIT-Guwahati <br />
                    Cleared: IIST, ISRER <br />
                    2021-22 Batch
                  </p>
                </div>
              </div>
              <div className="jeemainsbox">
                <div className="jeemainsboximg">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/JEEMAINS2023-5.jpg"
                    className="img-fluid"
                  />
                </div>
                <div className="jeemainsboxdesc">
                  <p>
                    Adwait Gupta <br />
                    (2022-23 Batch) <br />
                    Cleared NDA (SSB, CPSS) 2023
                  </p>
                </div>
              </div>
              <div className="jeemainsbox">
                <div className="jeemainsboximg">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/JEEMAINS2023-6.jpg"
                    className="img-fluid"
                  />
                </div>
                <div className="jeemainsboxdesc">
                  <p>
                    Name: Bhuwan Chandra Pandey <br />
                    Joined NSUT <br />
                    2022-23 Batch
                  </p>
                </div>
              </div>
              <div className="jeemainsbox">
                <div className="jeemainsboximg">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/JEEMAINS2023-7.jpg"
                    className="img-fluid"
                  />
                </div>
                <div className="jeemainsboxdesc">
                  <p>
                    Name: Aakash Nath Jha <br />
                    Joined NSUT <br />
                    2022-23 Batch{" "}
                  </p>
                </div>
              </div>
              <div className="jeemainsbox">
                <div className="jeemainsboximg">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/JEEMAINS2023-8.jpg"
                    className="img-fluid"
                  />
                </div>
                <div className="jeemainsboxdesc">
                  <p>
                    {" "}
                    Name: D Prem Kowshik <br />
                    Joined BITS Pilani - Goa <br />
                    2022-23 Batch
                  </p>
                </div>
              </div>
              <div className="jeemainsbox">
                <div className="jeemainsboximg">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/JEEMAINS2023-9.jpg"
                    className="img-fluid"
                  />
                </div>
                <div className="jeemainsboxdesc">
                  <p>
                    Name: Ashwini Kumar Singh <br />
                    Pursuing MBBS MTMC, Jamshedpur <br />
                    2022-23 Batch{" "}
                  </p>
                </div>
              </div>
              <div className="jeemainsbox">
                <div className="jeemainsboximg">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/JEEMAINS2023-10.jpg"
                    className="img-fluid"
                  />
                </div>
                <div className="jeemainsboxdesc">
                  <p>
                    Name: Sumit Kumar <br />
                    Pursuing MBBS Rajiv Gandhi Medical College Thane <br />
                    2022-23 Batch
                  </p>
                </div>
              </div>
              <div className="jeemainsbox">
                <div className="jeemainsboximg">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/JEEMAINS2023-11.jpg"
                    className="img-fluid"
                  />
                </div>
                <div className="jeemainsboxdesc">
                  <p>
                    Name: N Sagarika <br />
                    Pursuing MBBS GMC ESI Coimbatore <br />
                    2021-22 Batch
                  </p>
                </div>
              </div>
              <div className="jeemainsbox">
                <div className="jeemainsboximg">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/JEEMAINS2023-12.jpg"
                    className="img-fluid"
                  />
                </div>
                <div className="jeemainsboxdesc">
                  <p>
                    Name: Tanya Mudel <br />
                    Pursuing MBBS Lady Harding college New Delhi <br />
                    2021-22 Batch{" "}
                  </p>
                </div>
              </div>
              <div className="jeemainsbox">
                <div className="jeemainsboximg">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/JEEMAINS2023-13.jpg"
                    className="img-fluid"
                  />
                </div>
                <div className="jeemainsboxdesc">
                  <p>
                    {" "}
                    Name: Shruti Chand <br />
                    Pursuing MBBS Rohilkhand Medical College and Hospital,
                    Bareilly <br />
                    2021-22 Batch{" "}
                  </p>
                </div>
              </div>
              <div className="jeemainsbox">
                <div className="jeemainsboximg">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/JEEMAINS2023-14.jpg"
                    className="img-fluid"
                  />
                </div>
                <div className="jeemainsboxdesc">
                  <p>
                    {" "}
                    Name: Aryaman Malik <br />
                    UPSC NDA (I) 2023 <br />
                    AIR 252 <br />
                    2022-23 Batch
                  </p>
                </div>
              </div>
              <div className="jeemainsbox">
                <div className="jeemainsboximg">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/JEEMAINS2023-15.jpg"
                    className="img-fluid"
                  />
                </div>
                <div className="jeemainsboxdesc">
                  <p>
                    {" "}
                    Name: Tanishq Manhas <br />
                    UPSC NDA (I) 2023 <br />
                    AIR 428 <br />
                    2022-23 Batch
                  </p>
                </div>
              </div>
            </div>
            <p>
              <b>2021-2022</b>
            </p>
            <div className="jeemains">
              <div className="jeemainsbox">
                <div className="jeemainsboximg">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/JEEMAINS2022-1.jpg"
                    className="img-fluid"
                  />
                </div>
                <div className="jeemainsboxdesc">
                  <p>
                    Rishabh Raj (2020-2021 Batch) <br />
                    JEE (Mains) 2022: AIR 6918 (99.247%ile) <br />
                    JEE (Advanced) 2022: AIR 4538 <br />
                    NDA (147) 2021: AIR 45{" "}
                  </p>
                </div>
              </div>
              <div className="jeemainsbox">
                <div className="jeemainsboximg">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/JEEMAINS2022-2.jpg"
                    className="img-fluid"
                  />
                </div>
                <div className="jeemainsboxdesc">
                  <p>
                    Vaibhav Ahuja (2021-2022 Batch) <br />
                    JEE (Mains) 2022: AIR 1852 (99.82%ile) <br />
                    JEE (Advanced) 2022: AIR 2425
                  </p>
                </div>
              </div>
              <div className="jeemainsbox">
                <div className="jeemainsboximg">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/JEEMAINS2022-3.jpg"
                    className="img-fluid"
                  />
                </div>
                <div className="jeemainsboxdesc">
                  <p>
                    {" "}
                    Abhijay Chaudhary (2021-22 Batch) <br />
                    Cleared SSB
                  </p>
                </div>
              </div>
              <div className="jeemainsbox">
                <div className="jeemainsboximg">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/JEEMAINS2022-4.jpg"
                    className="img-fluid"
                  />
                </div>
                <div className="jeemainsboxdesc">
                  <p>
                    Angad Chauhan (2021-22 Batch) <br />
                    Cleared NEET-UG (Rank-3166)
                  </p>
                </div>
              </div>
              <div className="jeemainsbox">
                <div className="jeemainsboximg">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/JEEMAINS2022-5.jpg"
                    className="img-fluid"
                  />
                </div>
                <div className="jeemainsboxdesc">
                  <p>
                    Yashmeet Kumar (2021-22 Batch) <br />
                    Cleared SSB
                  </p>
                </div>
              </div>
            </div>
            <h6>Information Booklets</h6>
            <p>
              <Link
                to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/NDA-Exam-2023.pdf"
                target="_blank"
              >
                {" "}
                N - NDA Exam 2023{" "}
              </Link>{" "}
              ,{" "}
              <Link
                to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/NDA-Notification.pdf"
                target="_blank"
              >
                {" "}
                NDA Notification{" "}
              </Link>
            </p>
            <p>
              <Link
                to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Neet-Exam-2023.pdf"
                target="_blank"
              >
                {" "}
                M - Neet Exam 2023{" "}
              </Link>
            </p>
            <p>
              <Link
                to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Others.pdf"
                target="_blank"
              >
                {" "}
                O - Others{" "}
              </Link>
            </p>
            <p>
              <Link
                to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Law-Entrance-Exam-2023.pdf"
                target="_blank"
              >
                {" "}
                L - Law Entrance Exam 2023{" "}
              </Link>
            </p>
            <p>
              <Link
                to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Engineering-Exam-2023.pdf"
                target="_blank"
              >
                {" "}
                E - Engineering Exam 2023{" "}
              </Link>
            </p>
            <h6>Previous Year Question Papers</h6>
            <p>
              <b>NDA</b>
            </p>
            <div className="col-lg-12">
              <ul className="list mainlist">
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/NDA-I-2022.pdf"
                    target="_blank"
                  >
                    {" "}
                    NDA I 2022 QP Math And General Ability{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/NDA-II-2022-QP-Mathematics.pdf"
                    target="_blank"
                  >
                    {" "}
                    NDA II 2022 QP Mathematics{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/NDA-II-2022-QP-General-Ability.pdf"
                    target="_blank"
                  >
                    {" "}
                    NDA II 2022 QP General Ability{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/NDA-2021-QP.pdf"
                    target="_blank"
                  >
                    {" "}
                    NDA 2021 QP{" "}
                  </Link>
                </li>
              </ul>

              <p>
                <b>NEET</b>
              </p>
              <ul className="list mainlist">
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/NEET-2022-QP.pdf"
                    target="_blank"
                  >
                    {" "}
                    NEET 2022 QP{" "}
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/NEET-2021-QP.pdf"
                    target="_blank"
                  >
                    {" "}
                    NEET 2021 QP{" "}
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/NEET-2020-QP.pdf"
                    target="_blank"
                  >
                    {" "}
                    NEET 2020 QP{" "}
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/NEET-2019-QP.pdf"
                    target="_blank"
                  >
                    {" "}
                    NEET 2019 QP{" "}
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/NEET-2018-QP.pdf"
                    target="_blank"
                  >
                    {" "}
                    NEET 2018 QP{" "}
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/NEET-2017-QP.pdf"
                    target="_blank"
                  >
                    {" "}
                    NEET 2017 QP{" "}
                  </Link>{" "}
                </li>
              </ul>
              <p>
                <b>CA</b>
              </p>
              <ul className="list mainlist">
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/MAY-2022-PAPER-2.pdf"
                    target="_blank"
                  >
                    {" "}
                    MAY 2022 - PAPER 2{" "}
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/MAY-2022-PAPER-1.pdf"
                    target="_blank"
                  >
                    {" "}
                    MAY 2022 - PAPER 1{" "}
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Dec-2021-PAPER-2.pdf"
                    target="_blank"
                  >
                    {" "}
                    DEC 2021 - PAPER 2{" "}
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Dec-2021-PAPER-1.pdf"
                    target="_blank"
                  >
                    {" "}
                    DEC 2021 - PAPER 1{" "}
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/JULY-2021-PAPER-2.pdf"
                    target="_blank"
                  >
                    {" "}
                    JULY 2021 - PAPER 2{" "}
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/JULY-2021-PAPER-1.pdf"
                    target="_blank"
                  >
                    {" "}
                    JULY 2021 - PAPER 1{" "}
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/jan-2021-PAPER-2.pdf"
                    target="_blank"
                  >
                    {" "}
                    JAN 2021 - PAPER 2{" "}
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/jan-2021-PAPER-1.pdf"
                    target="_blank"
                  >
                    {" "}
                    JAN 2021 - PAPER 1{" "}
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/nov-2020-PAPER-2.pdf"
                    target="_blank"
                  >
                    {" "}
                    NOV 2020 - PAPER 2{" "}
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/nov-2020-PAPER-1.pdf"
                    target="_blank"
                  >
                    {" "}
                    NOV 2020 - PAPER 1{" "}
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/nov-2019-PAPER-2.pdf"
                    target="_blank"
                  >
                    {" "}
                    NOV 2019 - PAPER 2{" "}
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/nov-2019-PAPER-1.pdf"
                    target="_blank"
                  >
                    {" "}
                    NOV 2019 - PAPER 1{" "}
                  </Link>{" "}
                </li>
              </ul>
              <p>
                <b>CLAT</b>
              </p>
              <ul className="list">
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/CLAT-2022-QP.pdf"
                    target="_blank"
                  >
                    {" "}
                    CLAT 2022 QP{" "}
                  </Link>{" "}
                </li>
              </ul>
            </div>

            <div className="col-lg-6">
              <p>
                <b>ENGINEERING</b>
              </p>
              <ul className="list">
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/JEE-Main-25-07-2022-Shift-1.pdf"
                    target="_blank"
                  >
                    {" "}
                    JEE-Main-25-07-2022-Shift-1 (Memory Based){" "}
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/JEE-Main-25-07-2022-Shift-2-phy.pdf"
                    target="_blank"
                  >
                    {" "}
                    JEE-Main-25-07-2022-Shift-2 (Memory Based){" "}
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/JEE-Main-25-07-2022-Shift-2-che.pdf"
                    target="_blank"
                  >
                    {" "}
                    JEE-Main-25-07-2022-Shift-2 (Memory Based){" "}
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/JEE-Main-25-07-2022-Shift-2-math.pdf"
                    target="_blank"
                  >
                    {" "}
                    JEE-Main-25-07-2022-Shift-2 (Memory Based){" "}
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/JEE-Main-26-07-2022-Shift-1-phy.pdf"
                    target="_blank"
                  >
                    {" "}
                    JEE-Main-26-07-2022-Shift-1 (Memory Based){" "}
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/JEE-Main-26-07-2022-Shift-1-che.pdf"
                    target="_blank"
                  >
                    {" "}
                    JEE-Main-26-07-2022-Shift-1 (Memory Based){" "}
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/JEE-Main-26-07-2022-Shift-2-math.pdf"
                    target="_blank"
                  >
                    {" "}
                    JEE-Main-26-07-2022-Shift-2 (Memory Based){" "}
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/JEE-Main-27-07-2022-Shift-1-che.pdf"
                    target="_blank"
                  >
                    {" "}
                    JEE-Main-27-07-2022-Shift-1 (Memory Based){" "}
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/JEE-Main-27-07-2022-Shift-1-phy.pdf"
                    target="_blank"
                  >
                    {" "}
                    JEE-Main-27-07-2022-Shift-1 (Memory Based){" "}
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/JEE-Main-28-07-2022-Shift-1phy.pdf"
                    target="_blank"
                  >
                    {" "}
                    JEE-Main-28-07-2022-Shift-1 (Memory Based){" "}
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/JEE-Main-28-07-2022-Shift-2-phy.pdf"
                    target="_blank"
                  >
                    {" "}
                    JEE-Main-28-07-2022-Shift-2 (Memory Based){" "}
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/JEE-Main-29-07-2022-Shift-1-phy.pdf"
                    target="_blank"
                  >
                    {" "}
                    JEE-Main-29-07-2022-Shift-1 (Memory Based){" "}
                  </Link>{" "}
                </li>
              </ul>
            </div>
            <div className="col-lg-6">
              <p>
                <b>WORKSHOPS 2022-2023</b>
              </p>
              <ul className="list">
                <li>
                  {" "}
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/NDA-Preparation.pdf"
                    target="_blank"
                  >
                    {" "}
                    NDA Preparation Webinar{" "}
                  </Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Workshop22-23.pdf"
                    target="_blank"
                  >
                    {" "}
                    Workshop : How to be successful in life{" "}
                  </Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/CUETworkshop.pdf"
                    target="_blank"
                  >
                    {" "}
                    CUET and Popular Careers Workshop{" "}
                  </Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Entrepreneurshipworkshop.pdf"
                    target="_blank"
                  >
                    {" "}
                    Workshop On Entrepreneurship{" "}
                  </Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Indigenisationworkshop.pdf"
                    target="_blank"
                  >
                    {" "}
                    Navy’s Seminar on Innovation and Indigenisation{" "}
                  </Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/PreparationWorkshop.pdf"
                    target="_blank"
                  >
                    {" "}
                    NDA Exam Preparation Workshop{" "}
                  </Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/JEE-NEET-Entrance.pdf"
                    target="_blank"
                  >
                    {" "}
                    JEE and NEET Entrance Examination Workshop{" "}
                  </Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Career-Guidance-Workshop.pdf"
                    target="_blank"
                  >
                    {" "}
                    Career Guidance Workshop{" "}
                  </Link>{" "}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CareerCornerMissionMole;
